import { companyBillingPath } from '~/routes'

const LEGACY_UNITS = ['single', 'single_lite', 'flex', 'unlimited']

// Identifies the flow that opened the upgrade dialog. Drives both the dialog copy
// and the post-upgrade "return to Create Course" behavior.
export const UPGRADE_SOURCE_COURSE_AUTHORING = 'course_authoring'

// Query flag used on the Course Authoring page to re-open the Create Course modal
// after the user returns from a successful upgrade.
export const REOPEN_CREATE_COURSE_PARAM = 'create_course'

export const buildUpgradeUrl = (company, { restrictUnit, source } = {}) => {
  const params = new URLSearchParams({ upgrade: 'true' })

  if (LEGACY_UNITS.includes(company?.licenseUnit)) {
    params.set('plan_package', 'lms_package')
    params.set('mode', 'upgrade_lms')
  }

  if (restrictUnit) {
    params.set('restrict_unit', restrictUnit)
  }

  if (source) {
    params.set('source', source)
  }

  return `${companyBillingPath(company.id)}?${params.toString()}`
}
